// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddButton_wrapper__MJsMq","btn":"AddButton_btn__1BQ_9"};